import api from './base';

async function fetchList() {
    return api.call('prices/fuelPrice');
}

async function updateAll() {
    return api.call('prices/fuelPrice/updateAll', {}, 'put');
}

async function updateOne(data) {
    return api.call('prices/fuelPrice', data, 'put');
}

/**
 * @param {{
 *  date: string, 
 *  isArea?: boolean,
 *  entityId: string,
 * }} filter date must be format yyyy-mm-dd
 */
const getFuelPriceFiltered = async ({ date, entityId, isArea = false }) => api.call(`prices/fuelPriceById/${entityId}`, { date, isArea }, 'post');

const getFuelPriceFilteredV2 = async ({ date, entityId, isArea = false }) => 
    api.callV2(`prices/fuel/getByPortId/${entityId}`, { date, isArea }, 'post');

export default {
    fetchList,
    updateOne,
    updateAll,
    getFuelPriceFiltered,
    getFuelPriceFilteredV2,
};



// WEBPACK FOOTER //
// ./app/services/fuel.js